import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Dashboard from '../Dashboard/Dashboard';
import { useState } from 'react';
import TabPanel from './TabPanel';
import DashboardDataTable from '../DataTable/DashboardDataTable';
import LineChart from '../Chart/LineChart/LineChart';
import Timesheet from '../Timesheet/Timesheet';

function GenerateTabPanelProps(index: number) {
  return {
    id: `dashboard-tab-${index}`,
    'aria-controls': `dashboard-tabpanel-${index}`,
  };
}

const DashboardTab = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setCurrentIndex(newValue);
    };

    return (
    <Box sx={{ width: '100%' }}>
        <main>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={currentIndex} onChange={handleChange} aria-label="Summary/Data tabs">
                    <Tab label="Summary" {...GenerateTabPanelProps(0)} />
                    <Tab label="Chart" {...GenerateTabPanelProps(1)} />
                    <Tab label="Timesheet" {...GenerateTabPanelProps(2)} />
                    <Tab label="Data" {...GenerateTabPanelProps(3)} />
                </Tabs>
            </Box>
            <TabPanel currentIndex={currentIndex} index={0}>
                <Dashboard/>
            </TabPanel>
            <TabPanel currentIndex={currentIndex} index={1}>
                <LineChart/>
            </TabPanel>
            <TabPanel currentIndex={currentIndex} index={2}>
                <Timesheet/>
            </TabPanel>
            <TabPanel currentIndex={currentIndex} index={3}>
                <DashboardDataTable/>
            </TabPanel>
        </main>
    </Box>
    );
}

export default DashboardTab;